import { render } from "./PayrollTaxLiability.vue?vue&type=template&id=a421913c&scoped=true"
import script from "./PayrollTaxLiability.vue?vue&type=script&lang=js"
export * from "./PayrollTaxLiability.vue?vue&type=script&lang=js"

import "./PayrollTaxLiability.vue?vue&type=style&index=0&id=a421913c&scoped=true&lang=css"
import "./PayrollTaxLiability.vue?vue&type=style&index=1&id=a421913c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a421913c"]])

export default __exports__